import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { eventChartReducer, eventChartsFeatureKey } from './event-chart.reducer';
import { eventEntryFilterReducer, eventEntryFiltersFeatureKey } from './event-entry-filter.reducer';
import { eventEntriesFeatureKey, eventEntryReducer } from './event-entry.reducer';
import { EventTotalEffects } from './event-total.effects';
import { eventTotalFeatureKey, eventTotalReducer } from './event-total.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(eventChartsFeatureKey, eventChartReducer),
    StoreModule.forFeature(eventEntriesFeatureKey, eventEntryReducer),
    StoreModule.forFeature(eventTotalFeatureKey, eventTotalReducer),
    StoreModule.forFeature(eventEntryFiltersFeatureKey, eventEntryFilterReducer),
    EffectsModule.forFeature([EventTotalEffects])
  ]
})
export class EventStoreModule {}
